<template>
  <div class="card shadow ani-scale-box" :class="cardBgColor">
    <div class="card-body">
      <div class="float-end">
        <div class="text-muted avatar-sm mx-auto mb-4">
          <span class="avatar-title rounded-circle bg-light font-size-24">
            <i :class="`mdi ${iconImage} text-${iconColor}`" />
          </span>
        </div>
      </div>
      <div>
        <p class="text-uppercase fw-semibold">{{ title }}</p>
        <h4 class="mb-1 mt-1">
          <span class="main-value">
            <countTo :startVal="0"
                     :endVal="endVal"
                     :duration="1000" />
          </span>
          <span class="sub-value">{{ valueTitle }}</span>
          <template v-if="!$_utils.isEmpty(totVal)">
            <span class="main-value"> / </span>
            <span class="sub-value">{{ totVal }} {{ valueTitle }}</span>
          </template>
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';

export default {
  components: { countTo },
  props: {
    cardBg: String,
    iconImage: String,
    iconColor: {type: String, default: 'secondary'},
    title: String,
    valueTitle: String,
    endVal: {type: Number, default: 0},
    totVal: Number
  },
  computed: {
    cardBgColor() {
      return 'bg-' + this.cardBg + '-gradient';
    }
  }
}
</script>
